export default "/images/HDAW_STEP_2.png";